import React, {useState} from 'react';
import { ProgressHeader } from './ProgressHeader';
import T from '../../components/Translation';
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv';
import Divider from '../../whitaijiFrontendLibrary/components/Divider';

export const StepByStepProgress = ({progressList, validationErrors = {}}) => {

    const [progressTab, setProgressTab] = useState({...progressList[0], index: 0})

    const activeIndex = progressTab?.index ?? 0

    const nextStep = () => {
        //process.env.NODE_ENV === "development" && console.log("NEXT STEP")
        setProgressTab({...progressList[activeIndex+1], index: activeIndex+1})
    }
    const previousStep = () => {
        //process.env.NODE_ENV === "development" && console.log("PREVIOUS STEP")
        setProgressTab({...progressList[activeIndex-1], index: activeIndex-1})
    }
  return (
    <div>
        <ProgressHeader 
            progressTab={progressTab} 
            setProgressTab={setProgressTab} 
            progressList={progressList}
            validationErrors={validationErrors}
        />
        {progressList?.map((item, index)=>{
            return(
                <VisDiv key={index}  rules={[progressTab?.index === index]}>
                    <h3 style={{display: 'flex', alignItems: 'center', marginBottom:"10px"}}>{index+1}.{item?.tabTitle}</h3>
                    {item?.component}
                </VisDiv>
            )
        })}
        <Divider/>
        <VisDiv style={{display:"flex", justifyContent:"space-around"}}>
            <VisDiv>
               {activeIndex>0 && <button className='pdf-button' onClick={previousStep}><T str="previous" /></button>}
            </VisDiv>
            <VisDiv>
                {activeIndex < progressList?.length - 1 && <button className='pdf-button' onClick={nextStep}><T str="next" /></button>}
            </VisDiv>
        </VisDiv>
      
    </div>
  )
}
